import { OnInit, ElementRef, } from "@angular/core";
import { ThumbnailBuilderService } from "../testimonials-panel/service/thumbnail-builder.service";
import get from "lodash.get";
import { MqService } from "../../service/mq.service";
import { applyTitleSettings } from "../../shared/utils/title-style-settings-utils";
import Splide from "@splidejs/splide";
var TestimonialsPanelComponent = /** @class */ (function () {
    function TestimonialsPanelComponent(mq, thumbnailBuilder) {
        this.mq = mq;
        this.thumbnailBuilder = thumbnailBuilder;
        this.tabletMediaQuery = "(min-width: 1024px)";
        this.items = [];
        this.topWave = false;
        this.bottomWave = false;
        this.forceHideQuoteId = 0;
        this.isReadMoreActive = false;
        this.isMobile = this.mq.isMidi();
    }
    Object.defineProperty(TestimonialsPanelComponent.prototype, "isBigPictures", {
        get: function () {
            return this.data.bigPictures && this.data.bigPictures.value;
        },
        enumerable: true,
        configurable: true
    });
    TestimonialsPanelComponent.prototype.ngOnInit = function () {
        this.mapData();
    };
    TestimonialsPanelComponent.prototype.ngAfterViewInit = function () {
        if (this.data.capitalizeTitle.value)
            this.titleEl.nativeElement.style.textTransform = "uppercase";
        applyTitleSettings(this.data, this.titleEl);
        if (this.data.itemAuthorSize && this.data.itemAuthorSize.value) {
            this.wrapperEl.nativeElement.style.setProperty("--testimonials-panel-author-size", this.data.itemAuthorSize.value);
        }
        if (this.data.itemAuthorFontWeight &&
            this.data.itemAuthorFontWeight.value) {
            this.wrapperEl.nativeElement.style.setProperty("--testimonials-panel-author-font-weight", this.data.itemAuthorFontWeight.value);
        }
        if (this.data.itemQuoteSize && this.data.itemQuoteSize.value) {
            this.wrapperEl.nativeElement.style.setProperty("--testimonials-panel-quote-size", this.data.itemQuoteSize.value + "px");
        }
        if (this.data.itemQuoteFontWeight && this.data.itemQuoteFontWeight.value) {
            this.wrapperEl.nativeElement.style.setProperty("--testimonials-panel-quote-font-weight", this.data.itemQuoteFontWeight.value + "px");
        }
        if (this.data.itemQuoteSize && this.data.itemQuoteSize.value) {
            this.wrapperEl.nativeElement.style.setProperty("--testimonials-panel-subtitle-size", this.data.itemQuoteSize.value + "px");
        }
        if (this.data.itemQuoteFontWeight && this.data.itemQuoteFontWeight.value) {
            this.wrapperEl.nativeElement.style.setProperty("--testimonials-panel-subtitle-font-weight", this.data.itemQuoteFontWeight.value + "px");
        }
        if (!this.splideInstance) {
            this.mountSlider();
        }
    };
    TestimonialsPanelComponent.prototype.ngOnDestroy = function () {
        if (this.splideInstance) {
            this.splideInstance.destroy();
        }
    };
    TestimonialsPanelComponent.prototype.mountSlider = function () {
        var options = {
            type: "loop",
            speed: 1000,
            padding: this.isBigPictures ? "15%" : "20%",
            autoplay: true,
            interval: 10000,
            updateOnMove: true,
            easing: "ease-in-out",
            breakpoints: {
                1240: {
                    padding: this.isBigPictures ? "15%" : 0,
                },
                1024: {
                    gap: "16px",
                    padding: 0,
                    perPage: 1,
                },
            },
        };
        this.splideInstance = new Splide(this.splideRoot.nativeElement, options);
        this.splideInstance.mount();
    };
    TestimonialsPanelComponent.prototype.onReadMoreActivated = function () {
        this.isReadMoreActive = !this.isReadMoreActive;
    };
    TestimonialsPanelComponent.prototype.mapData = function () {
        var _this = this;
        this.items = this.data.items.value;
        this.items.forEach(function (item) {
            if (item.media && item.media.value) {
                if (item.media.value.video) {
                    var desktop = item.media.value.video.desktop;
                    var mobile = item.media.value.video.mobile;
                    item.media.value.video = {
                        desktop: desktop || mobile,
                        mobile: mobile || desktop,
                    };
                }
                if (item.media.value.image) {
                    var desktop = item.media.value.image;
                    var mobile = item.mobileMedia && item.mobileMedia.value;
                    var mSrc = void 0;
                    var mAlt = void 0;
                    if (mobile) {
                        mSrc = mobile.src || desktop.src;
                        mAlt = mobile.alt || desktop.alt;
                    }
                    else {
                        mAlt = desktop.alt;
                        mSrc = desktop.src;
                    }
                    item.imageData = {
                        desktopAlt: desktop.alt,
                        desktopSrc: desktop.src,
                        mobileSrc: mSrc,
                        mobileAlt: mAlt,
                    };
                }
            }
            item.videoData = _this.isMobile ? _this.mobile(item) : _this.desktop(item);
            item.isShow = false;
            item.bigPictures = _this.data.bigPictures.value;
        });
        this.data.waves.value.forEach(function (item) {
            switch (item) {
                case "Top Wave":
                    _this.topWave = true;
                    break;
                case "Bottom Wave":
                    _this.bottomWave = true;
                    break;
            }
        });
    };
    TestimonialsPanelComponent.prototype.mobile = function (item) {
        return this.prepareVm(get(item, "media.value.video.mobile"));
    };
    TestimonialsPanelComponent.prototype.desktop = function (item) {
        return this.prepareVm(get(item, "media.value.video.desktop"));
    };
    TestimonialsPanelComponent.prototype.prepareVm = function (data) {
        if (!data)
            return null;
        return {
            thumbnail: this.thumbnailBuilder.create(data.thumbnail),
            params: "?controls=1&muted=0&autoplay=1&showinfo=0",
            video: {
                url: data.url,
                type: data.type,
            },
        };
    };
    TestimonialsPanelComponent.prototype.openVideoModal = function (item) {
        item.isShow = true;
        this.splideInstance.Components.Autoplay.pause();
    };
    TestimonialsPanelComponent.prototype.closeVideoModal = function (item) {
        item.isShow = false;
        this.splideInstance.Components.Autoplay.play();
    };
    return TestimonialsPanelComponent;
}());
export { TestimonialsPanelComponent };
